import { ApiModule, NetworkHelper } from '../module/index';
import { Cars, Suggest, Configurator } from './../../types';
import { Observable, of } from 'rxjs';
import { map, mergeMap, delay, repeatWhen } from 'rxjs/operators';

export namespace CarService {
  export const carSuggests = (query: string): Observable<Suggest.CarsSuggest[]> => {
    return ApiModule.get()
      .apiML.get<{
        data: Suggest.CarsSuggest[];
      }>('/rental-places', {
        query,
      })

      .pipe(
        map((it) => it.data),
        map((it) => it.filter((item) => item.iata))
      );
  };

  export const asyncSearch = (body: Cars.SearchRequestBody) => {
    const testTool: Configurator.State = Configurator.builder();
    if (testTool) {
      body.payload.test = testTool.carModule.testOn;
    }
    return ApiModule.get().workflowApi.post<Cars.InitAsyncSearchResponse>(
      '/v1/job',
      body,
      NetworkHelper.getUTMParams()
    );
  };

  export const getOffer = (offerId: string) => {
    return ApiModule.get().workflowApi.get<Cars.OfferDetailsResponse>(`/qm/offer/${offerId}`);
  };

  export const performSearchByJobId = (jobId: String) => {
    return of([1])
      .pipe(
        mergeMap((it) => {
          return ApiModule.get().workflowApi.get<Cars.AsyncSearchResponse>(
            `/v1/job/${jobId}`,
            NetworkHelper.getUTMParams()
          );
        })
      )
      .pipe(repeatWhen((notif) => notif.pipe(delay(300))));
  };
}
